export const fundListNb = {
    errors: {
        fundList: {
            fetchErrorTitle: 'Vi får ikke hentet fondene akkurat nå',
            paginationFetchErrorTitle: 'Kunne ikke laste flere fond',
            paginationFetchErrorDetails: 'Beklager, noe gikk galt ved lasting av flere fond. Vennligst prøv igjen, eller kom tilbake senere.',
        },
    },
    fundList: {
        header: 'Fondslisten',
        emptyState: 'Ingen fond er tilgjengelige akkurat nå.',
        infoModal: {
            title: 'Forklaring til fondslisten',
            openScreenReaderText: 'Forklaring til fondslisten',
            closeScreenReaderText: 'Lukk',
            buttonText: 'Forklaring til fondslisten',
        },
        symbolList: {
            morningstarSustainabilityRating: 'Bærekrafts\u00ADrangering fra Morningstar',
            yearlyCost: 'Årlig kostnad',
            minimumAmount: 'Minste\u00ADbeløp',
            summaryRiskIndicator: 'Risiko',
            fundDevelopment: 'Verdi\u00ADutvikling',
            eikaFundAndOtherFunds: '“Eika-fond” og “Andre fond”',
            yearlyCostExample: 'Årlig kostnad %',
            minimumAmountExample: 'Min. kr',
            fundDevelopmentExample: '+ % eller - %',
        },
        fundTypes: {
            equity: 'Aksjefond',
            fixedIncome: 'Rentefond',
            balanced: 'Kombinasjons\u00ADfond',
            alternative: 'Alternativt fond',
            index: 'Indeksfond',
        },
        regionLabels: {
            norway: 'Norge',
            europeNorth: 'Norden',
            sweden: 'Sverige',
            baltics: 'Baltiske stater',
            europe: 'Europa',
            global: 'Globalt',
            unitedStatesOfAmerica: 'USA (De forente stater)',
            asiaPacific: 'Asia-Stillehavs\u00ADregionen',
            asiaPacificExJapanExAustralia: 'Asia-Stillehavs\u00ADregionen ekskl. Japan og Australia',
            japan: 'Japan',
            india: 'India',
            brazil: 'Brasil',
            china: 'Kina',
            chinaGreater: 'Større Kina (inkl. Hongkong og Taiwan)',
            thailand: 'Thailand',
            latinAmerica: 'Latin-Amerika',
            bricBrazilRussiaIndiaAndChina: 'BRIC (Brasil, Russland, India og Kina)',
            europeEmergingMarkets: 'Frem\u00ADvoksende markeder i Europa',
            globalEmergingMarkets: 'Globale frem\u00ADvoksende markeder',
            emergingEuropeMiddleEastAndAfrica: 'Frem\u00ADvoksende markeder i Europa, Midtøsten og Afrika',
        },
        riskLabel: 'Risiko',
        summaryRiskIndicatorAriaLabel: 'Risiko: {} av {}',
        minimumAmountLabel: 'Min. {}',
        minimumAmountAriaLabel: 'Minstebeløp: {}.',
        managementFeeLabel: 'Forvaltnings\u00ADhonorar',
        yearlyCostLabel: 'Årlig kostnad {}',
        yearlyCostAriaLabel: 'Årlig kostnad: {}.',
        developmentCardLabel: '{} år',
        developmentAriaLabel: '{}-års verdiutvikling: {} prosent.',
        morningstarSustainabilityRatingAriaLabel: 'Morningstar bærekraftsrangering: {} av 5.',
        notAvailableForOneTimePurchase: 'Fondet tilbyr kun månedlig sparing',
        notAvailableForPeriodicPurchase: 'Fondet tilbyr kun engangs\u00ADkjøp',
        controlsRegionLabel: 'Søk og filtrer fond',
        searchResultsHeading: 'Søkeresultater',
        numberOfHits: '{} treff',
        sortedNumberOfHits: 'Sortert liste klar. {} treff',
        numberOfHitsWithFilters: '{} treff ({} aktive filtre)',
        noResults: {
            ordinary: {
                title: 'Ingen treff i søk og filtre',
                filtersAndSearchBody: 'Ingen fond samsvarer med søket og filtrene. Prøv å justere søket eller fjerne noen av filtrene. Søk og filtre påvirker ikke anbefalingene fra fondsguiden.',
                filtersOnlyBody: 'Ingen fond samsvarer med filtrene. Prøv å justere eller fjerne noen av filtrene. Søk og filtre påvirker ikke anbefalingene fra fondsguiden.',
                searchOnlyBody: 'Ingen fond samsvarer med søket. Prøv å justere søket. Søk og filtre påvirker ikke anbefalingene fra fondsguiden.',
                unfilteredBody: 'Fondslisten har ingen treff. Søk og filtre påvirker ikke anbefalingene fra fondsguiden.',
            },
            title: 'Ingen treff på valgene dine',
            filtersAndSearchBody: 'Prøv å justere søket eller fjerne noen av filtrene for å finne fond som passer.',
            filtersOnlyBody: 'Prøv å justere eller fjerne noen av filtrene for å finne fond som passer.',
            searchOnlyBody: 'Prøv å justere søket for å finne fond som passer.',
        },
        sectionTags: {
            eikaFundsTag: 'Eika-fond',
            otherFundsTag: 'Andre fond',
            eikaFundsTagFiltered: 'Treff i Eika-fond',
            otherFundsTagFiltered: 'Andre treff',
        },
        search: {
            closeSearchButtonLabel: 'Lukk og nullstill søk',
            openSearchButtonLabel: 'Søk i fondslisten',
            searchInputAriaLabel: 'Søk etter fond',
        },
        filters: {
            clearAllFilters: 'Fjern alle filtre',
            resetFilters: 'Nullstill',
            filterButton: 'Filter',
            filterButtonScreenReaderText: 'Filtrer fondslisten',
            filterModalTitle: 'Filtrer fondene',
            closeFilterModalScreenReaderText: 'Lukk filter',
            riskFilterLabel: 'Risiko\u00ADnivå',
            riskChipLabel: 'Risiko',
            morningstarSustainabilityRatingFilterLabel: 'Bærekrafts\u00ADrangering',
            morningstarSustainabilityRatingChipLabel: 'Bærekraft',
            regionFilterLabel: 'Region',
            regionFilterOptions: {
                global: 'Globalt marked',
                europeNorth: 'Europa (Nord-Europa)',
                norway: 'Norge',
            },
            fundTypeFilterLabel: 'Fondstype',
            totalFunds: '{} fond',
            showResults: 'Vis {} treff',
            noHitsButton: '0 treff',
            infoButtonScreenReaderText: 'Åpne forklaring om {}',
            indexFundOnlyLabel: 'Vis kun indeksfond',
            practicalFiltersLabel: 'Praktiske filtre',
            askCompatibleOnlyLabel: 'ASK-kompatibel',
            askCompatibleOnlyVisibleText: 'ASK',
            activeFiltersHeading: 'Aktive filtre',
            removeFilterAriaLabel: 'Fjern filter: {}',
        },
        queryPresets: {
            groupLabel: 'Fremhevede hurtigfilter',
            fundGuideLabel: 'Finn din fondstype',
            closeFundGuideLabel: 'Lukk fondsguide',
            highestSustainabilityRating: 'Best rangert bærekrafts\u00ADrisiko',
            nordicFunds: 'Norske og nordiske fond',
            globalFunds: 'Globale fond \u2013 bred dekning',
        },
        resultsCount: {
            ordinaryMatchesCountLabel: 'Treff i søk og filtre: {} fond',
            visibleFundsLabel: 'Viser {} fond',
            eikaFundsListLabel: 'Liste med {} Eika-fond.',
            otherFundsListLabel: 'Liste med {} andre fond.',
            allFundsListLabel: 'Liste med {} fond.',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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